export default class MediaUtils{
    static isMobileBrowser(){
        var os = (function() {
            var ua = navigator.userAgent,
              isWindowsPhone = /(?:Windows Phone)/.test(ua),
              isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
              isAndroid = /(?:Android)/.test(ua),
              isFireFox = /(?:Firefox)/.test(ua),
              isChrome = /(?:Chrome|CriOS)/.test(ua),
              isTablet =
                /(?:iPad|PlayBook)/.test(ua) ||
                (isAndroid && !/(?:Mobile)/.test(ua)) ||
                (isFireFox && /(?:Tablet)/.test(ua)),
              isPhone = /(?:iPhone)/.test(ua) && !isTablet,
              isPc = !isPhone && !isAndroid && !isSymbian;
            return {
              isTablet: isTablet,
              isPhone: isPhone,
              isAndroid: isAndroid,
              isPc: isPc
            };
        })();
        if (os.isAndroid || os.isPhone || os.isTablet) {
            return true;
        }
        return false;
  }
  
  static getCookieDomain(){
    return process.env.COOKIE_DOMAIN;
  }

  static getStaticDomain(){
    return process.env.STATIC_DOMAIN;
  }

  static getDesignURL(){
    return "https://home.icode.org.cn/design.html";
  }
  static getChrome(value){
    if(value==1){
      return "https://static.icode.org.cn/soft/ChromeStandaloneSetup.exe";
    }
    if(value==2){
      return "https://static.icode.org.cn/soft/ChromeStandaloneSetup64.exe";
    }
    return "https://static.icode.org.cn/soft/googlechrome.dmg";
  }

  static checkDevice(){
    var os = (() => {
      var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet =
          /(?:iPad|PlayBook)/.test(ua) ||
          (isAndroid && !/(?:Mobile)/.test(ua)) ||
          (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc,
      };
    })();
    // 使用方法
    if (os.isAndroid || os.isPhone || os.isTablet) {
      alert("移动端网站体验不佳，请在电脑端打开该网站");
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/MediaUtils.js